module.exports = __webpack_public_path__ + "819b9ceef3c44d119d178560079ef028.png";